import type { StockSymbol } from '@benzinga/session';
import type { DelayedQuote } from '@benzinga/quotes-manager';
import { formatTickerToURLFriendly } from '@benzinga/utils';
import { DefaultQuotesList } from '../Header/_mockMenu';

export interface MarketTickerProps {
  quotes?: Record<StockSymbol, DelayedQuote> | null;
  tickers?: string[];
}

const formatPrice = (value: number | string): string => {
  const n = Number(value);
  if (!Number.isFinite(n)) {
    return '—';
  }
  return n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

export const MarketTicker = ({ quotes, tickers = DefaultQuotesList }: MarketTickerProps) => (
  <div className="flex min-w-0 items-center gap-[18px] overflow-hidden">
    {tickers.map(ticker => {
      const quote = quotes?.[ticker] && !quotes[ticker].error ? quotes[ticker] : null;
      const symbol = quote?.symbol ?? ticker;
      const change = Number(quote?.change ?? 0);
      const directionClass =
        change > 0 ? 'text-[var(--hubnav-up)]' : change < 0 ? 'text-[var(--hubnav-down)]' : 'text-[var(--hubnav-util-fg)]';
      const sign = change > 0 ? '+' : change < 0 ? '−' : '';
      const percent =
        quote?.changePercent != null ? `${sign}${Math.abs(Number(quote.changePercent)).toFixed(2)}%` : '';

      return (
        <a
          className="inline-flex items-baseline gap-1.5 whitespace-nowrap text-xs font-medium tabular-nums text-[var(--hubnav-util-fg)] no-underline hover:[&_.sym]:underline focus-visible:rounded focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--hubnav-accent)]"
          data-action={`Quote Ticker Click - ${symbol}`}
          href={`/quote/${formatTickerToURLFriendly(symbol)}`}
          key={ticker}
        >
          <span className="sym font-bold tracking-[0.01em] text-[var(--hubnav-util-sym)]">{symbol}</span>
          <span className="text-[var(--hubnav-util-fg)]">{quote ? formatPrice(quote.lastTradePrice) : '—'}</span>
          {percent ? <span className={directionClass}>{percent}</span> : null}
        </a>
      );
    })}
  </div>
);
